import React from "react";
import ReactDOM from "react-dom/client";
import "@/utils/prerenderedHead";
import "@/index.css";
import App from "@/App";
import { installAdminFetchInterceptor } from "@/utils/adminFetch";

// Install the global fetch interceptor BEFORE React mounts so the very
// first admin API call already carries the X-Admin-Password header.
installAdminFetchInterceptor();

// Keep the prerendered markup visible (as a static copy) until the matched
// route has really rendered, so crawlers and users never see a blank gap.
const rootEl = document.getElementById("root");
if (rootEl.firstElementChild) {
  const shell = document.createElement("div");
  shell.id = "ssr-shell";
  shell.innerHTML = rootEl.innerHTML;
  rootEl.parentNode.insertBefore(shell, rootEl);
  rootEl.style.display = "none";
  window.__releaseSsrShell = () => {
    if (!shell.isConnected) return;
    shell.remove();
    rootEl.style.display = "";
  };
  setTimeout(window.__releaseSsrShell, 10000);
}

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
